import { useProductViewCommon } from '@/hooks/useProductViewCommon';
import { useProductViewDataSource } from '@/hooks/useProductViewDataSource';
import { ProductViewHook } from '@/types/product-view-model';
import { ProductViewModes } from '@/utils/productStateUtils';

/**
 * Hook used by the product Change Request route.
 *
 * Change Request mode loads the CR wrapper, exposes currentChanges, and saves
 * updates back through the Change Request API.
 */
export function useProductChangeRequest(): ProductViewHook {
  const dataSource = useProductViewDataSource(ProductViewModes.ChangeRequest);
  return useProductViewCommon(dataSource);
}
